<!---分享面板-->
<template>
  <SharePanel
    :layerName="layerName"
    :hasRedPacket="false"
    pageSource="icsapp"
    :shareChannelNames="['weixin', 'weixincircle']"
    @share="goShare"
  />
</template>
<script>
import { mapGetters } from 'vuex';
import * as layerNames from '@/services/layerName';
import * as constNames from '@/services/const.service';
import store from '@/store';
import SharePanel from './SharePanel.vue';
import shareManager from '@/services/share.manager';
import vrShowApi from '@/apis/vr.show.api';
const channelMap = { weixin: 1, weixincircle: 2 };

export default {
  name: 'IcsAppSharePanel',
  components: {
    SharePanel
  },
  props: {
    shareType: {
      type: String,
      default: ''
    },
    dealerId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters({
      functionData: 'functionData',
      saleSetting: 'sales/saleSetting',
      baseSalerInfo: 'sales/baseSalerInfo',
      icsRecords: 'sales/icsRecordsSalerInfo',
    }),
  },
  data () {
    return {
      layerName: layerNames.ICSAPP_SHARE_PANEL,
      dealerVrHasRtc: false
    };
  },
  mounted () {
    if (this.shareType) {
      this.getDealerVrHasRtc();// 店铺
    }
  },
  methods: {
    getDealerVrHasRtc () {
      vrShowApi.getSaleVrSetting(this.dealerId).then((data) => {
        if (data.returncode === 0) {
          this.dealerVrHasRtc = data.result && data.result.saleCount > 0;
        } else {
          console.error('getHasRtc', data.message);
        }
      }).catch((ex) => {
        console.error('getHasRtc', ex);
      });
    },
    goShare (channelName) {
      if (this.shareType) {
        this.shareVrTask(channelName);
      } else {
        this.share(channelName);
      }
    },
    share (channelName) {
      let shareplatform = channelMap[channelName];
      const dealerHasRtc = this.functionData.saleSetting && this.functionData.saleSetting.saleCount > 0;
      const saleHasRtc = this.saleSetting && this.saleSetting.acceptVisit;
      shareManager.setIcsAppShare({
        adviserInfo: this.baseSalerInfo,
        dealerHasRtc: dealerHasRtc,
        saleHasRtc: saleHasRtc,
        channelName,
        shareType: '',
        path: ''
      });
      if (shareplatform) {
        shareManager.shareEnv.doShare(shareplatform);
      }
    },
    shareVrTask (channelName) {
      const day = new Date().getDate();
      store.commit('busiIcsApp/setIcsShared', { shared: true, day, salesId: this.icsRecords.salesId });
      localStorage.setItem(constNames.ICS_SHARED, JSON.stringify({ shared: true, day, salesId: this.icsRecords.salesId }));
      let shareplatform = channelMap[channelName];
      let saleHasRtc = this.saleSetting && this.saleSetting.acceptVisit;
      shareManager.setIcsAppShare({
        adviserInfo: this.icsRecords,
        dealerHasRtc: this.dealerVrHasRtc,
        saleHasRtc,
        channelName,
        shareType: this.shareType,
        path: this.$route.query.path
      });
      if (shareplatform) {
        shareManager.shareEnv.doShare(shareplatform);
      }
    }
  }
};
</script>